import RegisterStep from "./RegisterStep";
import CompanyDetails from "./CompanyDetails";

const HandleRenderDiv = ({ pagename, backToLogin, onClose }) => {
  switch (pagename) {
    case "signup":
      return <RegisterStep backToLogin={backToLogin} />;
    case "afterLogin":
      return <CompanyDetails backToLogin={backToLogin} onClose={onClose} />;
  }
};

export default HandleRenderDiv;
